import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { AppConstants } from '../../app.constants';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class DataDirectoryService {
  serchKey = '';
  directory_data = '/assets/mockdata/DirectoryData.json';
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  postDirectoryData(key) {
    // return this.http.get(this.directory_data,key);
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.DATADIRECTORY.POST}`, key).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }



}





